import request from '@/utils/request'

const prefix = '/django_rest/custom_job_filter'
export default {
  searchJobCustomField: (params) => {
    return request.get(`${prefix}/`, { params })
  }
}
